import { useEffect, useState } from "react";
import { Trash2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { LANG_NAMES, errMsg } from "./useAuthedHttp";

export const ReviewersPanel = ({ call, allLangs }) => {
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  const [langs, setLangs] = useState([]);
  const load = () => call("get", "/translations/reviewers").then((d) => setList(d.reviewers)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = (l) => setLangs(langs.includes(l) ? langs.filter((x) => x !== l) : [...langs, l]);
  const save = async (e) => {
    e.preventDefault();
    try {
      const r = await call("put", "/translations/reviewers", { email, langs });
      toast.success(r.invited ? "Reviewer saved. Invite email sent." : "Reviewer saved");
      setEmail(""); setLangs([]); load();
    } catch (err) { toast.error(errMsg(err, "Enter a valid email and pick a language")); }
  };
  const remove = async (em) => { await call("delete", `/translations/reviewers/${encodeURIComponent(em)}`); load(); };

  return (
    <section className="rounded-2xl bg-white border border-[#1C242B]/10 p-6" data-testid="reviewers-panel">
      <h2 className="font-display font-bold text-lg">Trusted reviewers</h2>
      <p className="text-sm text-slate-500 mt-1">Add the Google email of each reviewer and the languages they may review.</p>
      <form onSubmit={save} className="mt-4 grid gap-3">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="reviewer@gmail.com" data-testid="reviewer-email-input"
          className="rounded-full border border-[#1C242B]/15 bg-[#FAF8F5] px-4 py-2.5 text-sm" />
        <div className="flex flex-wrap gap-2">
          {allLangs.map((l) => (
            <button type="button" key={l} lang={l} onClick={() => toggle(l)} data-testid={`reviewer-lang-${l}`}
              style={{ letterSpacing: 0 }} className={`rounded-full px-3 py-1.5 text-sm border transition-colors ${langs.includes(l) ? "bg-[#3E6B5C] text-white border-[#3E6B5C]" : "border-[#1C242B]/15 hover:bg-[#1C242B]/5"}`}>{LANG_NAMES[l] || l}</button>
          ))}
        </div>
        <button type="submit" disabled={!langs.length} data-testid="reviewer-save-btn"
          className="justify-self-start inline-flex items-center gap-2 rounded-full bg-[#D96B43] text-white px-5 py-2.5 text-sm font-semibold disabled:opacity-40 hover:bg-[#C05630] transition-colors"><UserPlus size={15} /> Save reviewer</button>
      </form>
      <ul className="mt-5 divide-y divide-[#1C242B]/10">
        {list.map((r) => (
          <li key={r.email} className="py-3 flex items-center gap-3 text-sm" data-testid={`reviewer-row-${r.email}`}>
            <span className="font-medium">{r.email}</span>
            <span className="text-slate-500">{r.langs.map((l) => LANG_NAMES[l] || l).join(", ")}</span>
            <button onClick={() => remove(r.email)} aria-label="Remove reviewer" data-testid={`reviewer-remove-${r.email}`} className="ml-auto p-2 rounded-full hover:bg-red-50 text-red-600 transition-colors"><Trash2 size={15} /></button>
          </li>
        ))}
        {!list.length && <li className="py-3 text-sm text-slate-500">No reviewers yet.</li>}
      </ul>
    </section>
  );
};
